// Le markdown restreint des textes de l'ABS (contrat `terobs.abs/1`, BlocTexte) : des paragraphes
// séparés par une ligne vide, des listes à puces (« - » ou « * » en début de ligne) et du **gras**.
// Rien d'autre : ni titres, ni liens, ni italique, ni HTML. L'analyseur rend une structure que le
// rendu React (TexteMarkdown.tsx) transforme en éléments ; aucun texte n'est jamais interprété
// comme du HTML, une balise écrite dans un texte s'affiche telle quelle.

export interface Segment { texte: string; gras: boolean }
export type BlocMarkdown =
  | { type: 'p'; segments: Segment[] }
  | { type: 'ul'; items: Segment[][] }

const PUCE = /^\s*[-*]\s+(.*)$/

/** Le gras d'une ligne : chaque paire de « ** » encadre un passage en gras ; un « ** » sans
    pendant reste du texte. */
export function enLigne(texte: string): Segment[] {
  const out: Segment[] = []
  const pousser = (t: string, gras: boolean) => {
    if (!t) return
    const dernier = out[out.length - 1]
    if (dernier && dernier.gras === gras) dernier.texte += t
    else out.push({ texte: t, gras })
  }
  let reste = texte
  for (;;) {
    const debut = reste.indexOf('**')
    const fin = debut < 0 ? -1 : reste.indexOf('**', debut + 2)
    if (debut < 0 || fin < 0) { pousser(reste, false); break }
    const dedans = reste.slice(debut + 2, fin)
    pousser(reste.slice(0, debut), false)
    // « **** » n'encadre rien : on le garde tel quel plutôt que d'avaler deux marques.
    if (dedans) pousser(dedans, true)
    else pousser('****', false)
    reste = reste.slice(fin + 2)
  }
  return out
}

export function analyserMarkdown(source: string): BlocMarkdown[] {
  const blocs: BlocMarkdown[] = []
  let paragraphe: string[] = []
  let liste: string[] = []
  const fermerParagraphe = () => {
    if (paragraphe.length) blocs.push({ type: 'p', segments: enLigne(paragraphe.join(' ')) })
    paragraphe = []
  }
  const fermerListe = () => {
    if (liste.length) blocs.push({ type: 'ul', items: liste.map(enLigne) })
    liste = []
  }
  for (const brute of source.replace(/\r\n?/g, '\n').split('\n')) {
    const ligne = brute.trim()
    if (!ligne) { fermerParagraphe(); fermerListe(); continue }
    const puce = PUCE.exec(ligne)
    if (puce) { fermerParagraphe(); liste.push(puce[1].trim()); continue }
    fermerListe()
    paragraphe.push(ligne)
  }
  fermerParagraphe()
  fermerListe()
  return blocs
}
